import pricingService from "@/services/pricingService";

export function getAllTestsAndDiscountPanelsApi(currency = "usd", addOnTubeInfo = false) {
  let url = `/item/price/getAllTestsAndDiscountPanels/${currency}`;
  if (addOnTubeInfo) {
    url += "?addon=tubeInfo";
  }
  return pricingService({
    url,
    method: "get",
  });
}

export function getCustomPanelsApi(currency = "usd", clinicId, customerId, accountType) {
  return pricingService({
    url: `/item/price/getAllCustomPanels/${currency}?clinic_id=${clinicId}&customer_id=${customerId}&account_type=${accountType}`,
    method: "get",
  });
}

export function getPromotionsApi(currency = "usd") {
  return pricingService({
    url: `/item/price/getAllPromotions/${currency}`,
    method: "get",
  });
}

export function getOfficialBundleMappingApi() {
  return pricingService({
    url: `/item/price/getItem2OfficialBundleMapping`,
    methoda: "get",
  })
}

export function getHighlightCardsApi(currency = "usd") {
  return pricingService({
      url: `/item/price/getHighlightCards?currency=${currency}`,
      method: "get",
    });
}

export function getBestDealMapping(currency = "usd") {
  return pricingService({
    url: `/item/price/getDataForBestDeal/${currency}`,
    method: "get",
  });
}
